import { render } from "./StartHubNotificationsCard.vue?vue&type=template&id=ea035d02"
import script from "./StartHubNotificationsCard.vue?vue&type=script&lang=js"
export * from "./StartHubNotificationsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__